const queryParams = (value) => {
  return Object.keys(value)
    .map((key) => key + '=' + value[key])
    .join('&')
}
export default queryParams
